import { Injectable } from '@angular/core';
import { HttpService } from '@ecp-caf/caf-common';
import { Observable } from 'rxjs';
import { AssigneeInfoByProcInstIdParameter, CompleteContext } from '../../entity';
import { AssigneeInfoByWorkItemIdParameter } from '../../entity/complete-response';

@Injectable()
export class TaskService {

    constructor(
        private httpSvc: HttpService
    ) { }
    /**
     * 获取工作项操作列表
     */
    getWorkItemActions(workItemId: string): Observable<any> {
        const url = `/api/runtime/wf/v1.0/workItems/${workItemId}/actions`;

        return this.httpSvc.get(url);
    }

    /**
     * 执行审批操作
     * @param taskId 任务Id
     * @param context 执行审批上下文
     */
    excuteTask(taskId: string, context: CompleteContext): Observable<any> {
        const url = `/api/runtime/wf/v1.0/workItems/complete`;
        context.workItemId = taskId;
        const options = {
            excuteParam: context
        };
        return this.httpSvc.post(url, context);
    }

    /**
     * 获取跳转活动信息
     * @param workItemId 工作项Id
     * @param action 动作编号
     */
    getDestinationScope(workItemId: string, action: string): Observable<any> {
        const url = `/api/runtime/wf/v1.0/workItems/${workItemId}/nextNodes/${action}`;
        return this.httpSvc.get(url);
    }
    /**
     * 获取动作实体进而获取web实现和前后事件
     * @param taskId 任务ID
     * @param action 动作编号
     */
    getActionEntity(taskId: string, action: string): Observable<any> {
        const url = `/api/runtime/wf/v1.0/approvalAction?code=${action}`;

        return this.httpSvc.get(url);
    }

    /**
     * 执行加签操作
     * @param context 加签上下文
     */
    addSign(context: any): Observable<any> {
        const url = `/api/runtime/wf/v1.0/workItems/counterSignAdd`;
        const body = {
            excuteParam: context
        };
        return this.httpSvc.post(url, context);
    }

    /**
     * 查询单据信息
     * @param workItemId 工作项Id
     */
    getAppInfo(workItemId: string): Observable<any> {
        const formParUrl = `/api/runtime/wf/v1.0/workItems/${workItemId}/formInfo`;
        return this.httpSvc.get(formParUrl);
    }
    //#region 查看流程
    /**
     * 基于工作项ID获取bpmnModel
     * @param workitemId 工作项id
     */
    getBpmnModelbyWorkItemId(workitemId: string): Observable<any> {
        const url = `/api/runtime/wf/v1.0/workItems/${workitemId}/bpmnModel`;
        return this.httpSvc.get(url);
    }
    /**
     * 基于工作项Id获取所有活动实例
     * @param id taskId
     */
    getAllActiInstsbyTaskId(id: string): Observable<any> {
        const url = `/api/runtime/wf/v1.0/workItems/activityInstanceSlims?workItemId=${id}`;

        return this.httpSvc.get(url);
    }
    /**
     * 基于活动实例Id获取日志
     * @param actInstId 活动实例Id
     */
    getActivityInstanceLogs(actInstId: string): Observable<any> {
        const url = `/api/runtime/wf/v1.0/workItems/activityInstanceLogs?activityInstanceId=${actInstId}`;

        return this.httpSvc.get(url);
    }

    /**
     * 获取审批日志信息
     * @param taskId 工作项Id
     */
    getBizlogByTaskId(taskId: string): Observable<any> {
        const logUrl = `/api/runtime/wf/v1.0/workItems/${taskId}/fullComments`;
        // if (false === environment.production) {
        //     logUrl = '/assets/mock/taskbizlog.json';
        // }
        return this.httpSvc.get(logUrl);
    }
    //#endregion
    /**
     * 获取指派信息
     * @param taskId 工作项Id
     */
    getAssigneeInfo(taskId: string): Observable<any> {
        const url = `/api/runtime/wf/v1.0/workItems/${taskId}/assigneeInfo`;
        return this.httpSvc.get(url);
    }

    /**
     * 根据流程实例Id批量指派（提交审批或执行审批后指派弹框调用，_后续调整与工作项的一致_）
     * @param assigneesPa 指派参数
     */
    assignNextUsersByProcInstId(assigneesPa: AssigneeInfoByProcInstIdParameter): Observable<any> {
        const url = `/api/runtime/wf/v1.0/processInstances/assignNextUsers`;
        const body = {
            assigneeInfoParameter: assigneesPa
        };
        return this.httpSvc.post(url, assigneesPa);
    }
    /**
     * 根据工作项ID指派任务
     * @param assigneesPa 指派参数
     */
    assignNextUsersByWorkItemId(assigneesPa: AssigneeInfoByWorkItemIdParameter): Observable<any> {
        const url = `/api/runtime/wf/v1.0/workItems/assignUser`;
        const body = {
            assigneeInfoParameter: assigneesPa
        };
        return this.httpSvc.post(url, assigneesPa);
    }

    /**
     * 取回
     * @param workItemId task id
     * @param comment comment
     */
    retrieve(context: { workItemId: string, comment?: string }): Observable<any> {
        const url = `/api/runtime/wf/v1.0/workItems/retrieve`;

        const body = {
            excuteParam: context
        };
        return this.httpSvc.post(url, context);
    }
    /**
     * 任务移交
     * @param taskId 工作项Id
     * @param targetUId 目标用户Id
     */
    transfer(transferContext: any): Observable<any> {
        const url = `/api/runtime/wf/v1.0/workItems/transfer`;
        const body = {
            excuteParam: transferContext
        };
        return this.httpSvc.post(url, transferContext);
    }
    //#region  任务领用
    /**
     * 领用任务
     * @param taskId 工作项Id
     */
    claim(taskId: string): Observable<any> {
        const url = `/api/runtime/wf/v1.0/workItems/claim`;
        const options = {
            workItemId: taskId
        };
        return this.httpSvc.post(url, options);
    }

    /**
     * 取消领用
     * @param taskId 任务Id
     */
    unClaim(taskId: string): Observable<any> {
        const url = `/api/runtime/wf/v1.0/workItems/unclaim`;
        const options = {
            workItemId: taskId
        };
        return this.httpSvc.post(url, options);
    }
    //#endregion
}
